<template>
	<div>
		<div class="row gutter-sm q-mb-lg">
			<div class="col-xs-12 col-sm-12">
				<q-field :count="256">
					<q-input
						v-model="title"
						ref="title"
						:float-label="$t('title')"
						:error="$v.title.$error"
						@input="$v.title.$touch"
						:disable="!managePodcasts"
					/>
				</q-field>
			</div>

			<div class="col-xs-12 col-sm-12">
				<q-field :count="512">
					<q-input
						v-model="description"
						ref="description"
						:float-label="$t('introduction')"
						rows="1"
						:max-height="100"
						type="textarea"
						:error="$v.description.$error"
						@input="$v.description.$touch"
						:disable="!managePodcasts"
					/>
				</q-field>
			</div>

			<div class="col-xs-12 col-sm-12">
				<q-select
					v-model="tag"
					:options="optionTags"
					:float-label="$t('tags')"
					multiple
					chips
					filter
					autofocus-filter
					:disable="!managePodcasts"
				/>
			</div>

			<div class="col-xs-12 col-sm-12">
				<div class="row gutter-sm">
					<div class="col-xs-12 col-sm-6">
						<p class="caption">{{ $t('image') }}</p>
						<uploader
							content_type="images"
							@fileUploaded="imageUploaded"
							:multiple="false"
							:cropper="true"
							:aspect_ratio="52 / 29"
							:aspect_ratio_string="'52/29'"
							:disable="!managePodcasts"
						/>

						<p v-if="image_url" class="q-mt-md file-url">
							<q-icon name="fas fa-check" color="positive" />
							<a :href="image_url" target="_blank"> {{ $truncateLink(image_url) }}</a>
						</p>
					</div>
					<div class="col-xs-12 col-sm-6">
						<p class="caption">
							{{ $t('alt_image') }}
							<q-icon
								name="far fa-question-circle"
								size="1.5rem"
								color="grey"
								class="q-ml-sm q-pb-sm"
							>
								<q-tooltip
									class="custom-tooltip"
									anchor="top left"
									self="bottom right"
								>
									{{ $t('alt_image_information_helper') }}
								</q-tooltip>
							</q-icon>
						</p>
						<div class="flex justify-between">
							<template v-for="lang in languages" class="row flex">
								<q-field :count="170" :key="lang.id" v-if="lang.code === 'pt-br'">
									<q-input
										v-model="language_br"
										:float-label="$t(`${lang.name}`)"
										ref="language_br"
										:error="$v.language_br.$error"
										@input="$v.language_br.$touch"
									/>
								</q-field>
								<q-field :count="170" :key="lang.id" v-if="lang.code === 'en-us'">
									<q-input
										v-model="language_us"
										:float-label="$t(`${lang.name}`)"
										ref="language_us"
										:error="$v.language_us.$error"
										@input="$v.language_us.$touch"
									/>
								</q-field>
								<q-field :count="170" :key="lang.id" v-if="lang.code === 'es-es'">
									<q-input
										v-model="language_es"
										:float-label="$t(`${lang.name}`)"
										ref="language_es"
										:error="$v.language_es.$error"
										@input="$v.language_es.$touch"
									/>
								</q-field>
								<q-field :count="170" :key="lang.id" v-if="lang.code === 'fr-fr'">
									<q-input
										v-model="language_fr"
										:float-label="$t(`${lang.name}`)"
										ref="language_fr"
										:error="$v.language_fr.$error"
										@input="$v.language_fr.$touch"
									/>
								</q-field>
							</template>
						</div>
					</div>
				</div>
			</div>

			<div class="col-xs-12 col-sm-6">
				<q-field :helper="`${$t('date_to_unpublish')}`">
					<q-datetime
						v-model="unpublish_date"
						ref="unpublish_date"
						type="date"
						:float-label="$t('unpublish_date')"
						format="DD/MM/YYYY"
						clearable
						:disable="!managePodcasts"
					/>
				</q-field>
			</div>
		</div>

		<q-tabs v-model="tab" color="secondary" class="shadow-1">
			<q-tab
				slot="title"
				name="permissions"
				icon="fas fa-clipboard-check"
				:label="$t('permissions')"
			/>

			<q-tab-pane name="permissions" class="q-px-lg q-pb-xl">
				<div class="row gutter-sm">
					<div class="col-xs-12 col-sm-12">
						<select-multiple
							label="areas"
							:filters="area"
							:options="areas"
							@on_value="area = $event"
							:error="$v.area.$error"
							:input="$v.area.$touch"
							:disable="!managePodcasts"
						/>
					</div>

					<div class="col-xs-12 col-sm-12">
						<p class="caption">{{ $t('profiles') }}</p>

						<div class="row gutter-sm">
							<div class="col-xs-12 col-sm-12">
								<q-checkbox
									v-model="all_profiles"
									:val="true"
									:label="$t('all')"
									@input="checkAll()"
									:disable="!managePodcasts"
								/>
							</div>

							<div
								class="col-xs-12 col-sm-4"
								v-for="(item, index) in profiles"
								:key="index"
								:class="getErrorClass($v.profile.$error)"
							>
								<q-checkbox
									keep-color
									v-model="profile"
									ref="profile"
									:val="item.value"
									:label="item.label"
									@input="$v.profile.$touch"
									:color="getErrorColor($v.profile.$error)"
									:disable="!managePodcasts"
								/>
							</div>

							<div class="col-xs-12 col-sm-12">
								<q-select
									v-model="user_group"
									ref="user_group"
									:options="user_groups"
									:float-label="$t('groups')"
									:error="$v.user_group.$error"
									@input="$v.user_group.$touch"
									multiple
									chips
									:disable="!managePodcasts"
								/>
							</div>
						</div>
					</div>
				</div>

				<div class="row gutter-sm q-my-sm" v-if="id != 0 && title.length">
					<div class="col-xs-12 col-sm-11">
						<q-input
							v-model="url_podcast_portal"
							:float-label="$t('link')"
							:disable="true"
						/>
					</div>

					<div class="col-xs-12 col-sm-1 q-mt-lg">
						<q-btn
							dense
							color="primary"
							icon="far fa-copy"
							class="full-width"
							@click="copyLink()"
						>
							<q-tooltip>
								{{ $t('copy_link') }}
							</q-tooltip>
						</q-btn>
					</div>
				</div>
			</q-tab-pane>
		</q-tabs>

		<div class="row gutter-sm q-mt-xs">
			<div class="col-12">
				<q-chips-input
					v-model="owners_list"
					:float-label="$t('owners')"
					@remove="removeOwner"
					:disable="!managePodcasts"
				>
					<q-autocomplete
						@search="searchOwner"
						@selected="selectOwner"
						:min-characters="3"
						:value-field="(v) => `${v.full_name} - ${v.email}`"
					/>
				</q-chips-input>
			</div>
		</div>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
				<q-btn
					color="tertiary"
					class="full-width"
					:label="$t('back')"
					icon="fas fa-chevron-left"
					@click="$router.push({ name: 'admin_podcasts' })"
				/>
			</div>

			<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
				<q-btn
					color="secondary"
					class="full-width"
					:label="$t('save')"
					icon="far fa-save"
					@click="saveData()"
					:disable="!managePodcasts"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import Uploader from 'components/Uploader'
import { mapGetters } from 'vuex'
import { required, requiredIf, maxValue, minValue, maxLength } from 'vuelidate/lib/validators'
import { date } from 'quasar'
const { formatDate, addToDate } = date
import SelectMultiple from 'components/utils/SelectMultiple'

export default {
	props: ['managePodcasts'],

	data() {
		return {
			language_br: '',
			language_us: '',
			language_es: '',
			language_fr: '',
			id: '',
			title: '',
			description: '',
			image_url: '',
			area: [],
			profile: [],
			tag: [],
			user_group: [],
			tab: 'permissions',
			all_profiles: false,
			selected_client_params: [],
			owners: [],
			owners_list: [],
			unpublish_date: null,
		}
	},

	components: {
		uploader: Uploader,
		'select-multiple': SelectMultiple,
	},

	computed: {
		...mapGetters({
			languages: 'params/languages',
			access_token: 'common/access_token',
			clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected',
			areas: 'registration_lists/country_areas',
			user_groups: 'registration_lists/group_users',
			profiles: 'registration_lists/profiles',
			tags: 'registration_lists/tags',
			scores: 'registration_lists/group_training_scores',
			user_id: 'common/id',
			user_full_name: 'common/full_name',
			user_email: 'common/email',
		}),

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},

		optionTags() {
			if (this.tags.length > 0) {
				return this.tags.map((t) => {
					let areas = t.areas.map((a) => a.name)
					return {
						value: t.value,
						label: t.label,
						sublabel: areas.join(', '),
					}
				})
			} else return []
		},

		url_podcast_portal() {
			let url = process.env.SITE_URL ? process.env.SITE_URL : document.location.origin
			return `${url}/podcasts/${this.id}`
		},
	},

	methods: {
		fetchData() {
			this.$q.loading.show()

			this.$axios
				.get(`/admin_podcast/podcasts/${this.id}/`, this.getHeader)
				.then((response) => {
					this.id = response.data.id
					this.title = response.data.title
					this.description = response.data.description
					this.tag = response.data.tags
					this.profile = response.data.profiles
					this.area = response.data.areas
					this.user_group = response.data.user_groups

					if (response.data.podcast_image_alt_texts) {
						const altTextMap = {}
						response.data.podcast_image_alt_texts.forEach((altTextObj) => {
							altTextMap[altTextObj.language] = altTextObj.alt_text
						})
						this.language_br = altTextMap['pt-br'] || ''
						this.language_us = altTextMap['en-us'] || ''
						this.language_es = altTextMap['es-es'] || ''
						this.language_fr = altTextMap['fr-fr'] || ''
					}

					this.unpublish_date = response.data.unpublish_date
						? date.formatDate(response.data.unpublish_date, 'YYYY-MM-DDT00:00:00.SSSZ')
						: null
					if (this.unpublish_date)
						this.unpublish_date = addToDate(this.unpublish_date, { days: 1 })
					
					this.owners_list = []
					response.data.owners_list.forEach((owner) => {
						this.owners_list.push(`${owner.full_name} - ${owner.email}`)
						this.owners.push(owner.id)
					})

					let obj_img = response.data.podcast_playlist_images.find((obj) => {
						return obj.original === true
					})
					if (obj_img) this.image_url = obj_img.image
				})
				.catch((e) => {
					console.log(e)
					this.$router.push({ name: 'admin_podcasts' })
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		saveData() {
			this.$v.$touch()

			if (!this.$v.$error) {
				this.$q.loading.show()

				let requestData = {
					title: this.title,
					description: this.description,
					image_url_playlist_podcast: this.image_url,
					tags: this.tag,
					owners: this.owners,
					podcast_image_alt_texts: {
						'pt-br': this.language_br ? this.language_br : '',
						'en-us': this.language_us ? this.language_us : '',
						'es-es': this.language_es ? this.language_es : '',
						'fr-fr': this.language_fr ? this.language_fr : '',
					},
				}

				if (this.unpublish_date) {
					requestData.unpublish_date = date.formatDate(this.unpublish_date, 'YYYY-MM-DD')
				}

				if (this.area.length > 0 && this.profile.length > 0) {
					requestData.areas = this.area
					requestData.profiles = this.profile
				}

				if (this.user_group.length > 0) {
					requestData.user_groups = this.user_group
				}

				let apiUrl
				let httpMethod

				if (this.id != 0) {
					apiUrl = `/admin_podcast/podcasts/${this.id}/`
					httpMethod = 'put'
				} else {
					apiUrl = '/admin_podcast/podcasts/'
					httpMethod = 'post'
				}

				this.$axios[httpMethod](apiUrl, requestData, this.getHeader)
					.then((response) => {
						if (this.id == 0) {
							this.id = response.data.id
							this.$router.push({
								name: 'admin_podcast',
								params: { id: response.data.id },
							})
						}

						this.$q.notify({
							message: this.$t('basic_data_save_success'),
							type: 'positive',
							icon: 'far fa-save',
						})
					})
					.catch((e) => {
						console.log(e)

						this.$q.notify({
							message: this.$t('basic_data_save_error'),
							type: 'negative',
							icon: 'fas fa-ban',
						})
					})
					.finally(() => {
						this.$q.loading.hide()
					})
			} else {
				this.$formInputErrorFocus(this.$v, this.$refs)
				this.$q.notify({
					message: this.$t('make_sure_that_all_fields_are_filled_in'),
					type: 'negative',
					icon: 'fas fa-exclamation-triangle',
					position: 'top',
				})
			}
		},

		imageUploaded(url) {
			this.image_url = url
		},

		checkAll() {
			if (this.all_profiles) {
				this.profiles.forEach((element) => {
					this.profile.push(element.value)
				})
			} else {
				this.profile = []
			}
		},

		getErrorColor(state) {
			if (state) return 'negative'
			else return ''
		},

		getErrorClass(state) {
			if (state) return 'checkbox-error'
			else return ''
		},

		getOrder(name) {
			if (name == 'cancel') {
				if (this.$q.platform.is.mobile) return 'order-last'
				else return 'order-first'
			} else if (name == 'save') {
				if (this.$q.platform.is.mobile) return 'order-first'
				else return 'order-last'
			}
		},

		searchOwner(terms, done) {
			this.$axios
				.get(`/accounts/get_owners/?search=${terms}`, this.getHeader)
				.then((response) => {
					let users = []

					response.data.forEach((element) => {
						users.push({
							value: element.id,
							label: `${element.full_name} - ${element.email}`,
							full_name: element.full_name,
							email: element.email,
							id: element.id,
						})
					})

					done(users)
				})
				.catch((e) => {
					done([])
					console.log(e)
				})
		},

		selectOwner(item, keyboard) {
			if (!keyboard) this.owners.push(item.id)
		},

		removeOwner({ index, value }) {
			this.owners.splice(index, 1)
		},
		copyLink() {
			this.$copyText(this.url_podcast_portal).then(
				(e) => {
					this.$q.notify({
						message: this.$t('link_copied_to_clipboard'),
						type: 'positive',
						icon: 'far fa-copy',
					})
				},
				(e) => {
					console.log(e)
				}
			)
		},
	},

	created() {
		this.id = this.$route.params.id

		if (this.id) this.fetchData()
		else {
			this.owners.push(this.user_id)
			this.owners_list.push(`${this.user_full_name} - ${this.user_email}`)
		}

		let client = this.clients.find((obj) => {
			return obj.id === this.id_user_client_selected
		})
		this.selected_client_params = client ? client : {}
	},

	watch: {
		$route: function(refreshPage) {
			this.id = this.$route.params.id

			if (this.id) this.fetchData()
			else {
				this.owners.push(this.user_id)
				this.owners_list.push(`${this.user_full_name} - ${this.user_email}`)
			}

			let client = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			this.selected_client_params = client ? client : {}
		},
	},

	validations() {
		return {
			title: { required, maxLength: maxLength(256) },
			language_br: { maxLength: maxLength(170) },
			language_us: { maxLength: maxLength(170) },
			language_es: { maxLength: maxLength(170) },
			language_fr: { maxLength: maxLength(170) },
			description: { required, maxLength: maxLength(512) },
			area: {
				requiredIf: requiredIf(() => {
					if (this.profile.length == 0 && this.area.length == 0) {
						if (
							this.profile.length == 0 &&
							this.area.length == 0 &&
							this.user_group.length == 0
						)
							return true
						else return false
					} else {
						return true
					}
				}),
			},
			profile: {
				requiredIf: requiredIf(() => {
					if (this.profile.length == 0 && this.area.length == 0) {
						if (
							this.profile.length == 0 &&
							this.area.length == 0 &&
							this.user_group.length == 0
						)
							return true
						else return false
					} else {
						return true
					}
				}),
			},
			user_group: {
				requiredIf: requiredIf(() => {
					if (
						this.profile.length == 0 &&
						this.area.length == 0 &&
						this.user_group.length == 0
					) {
						return true
					} else {
						return false
					}
				}),
			},
		}
	},
}
</script>

<style></style>
